import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
    container: {
        minWidth: "300px",
        maxWidth: "600px",
        marginLeft: "auto",
        marginRight: "auto",
        padding: theme.spacing(2)
    }
});

type ContainerProps = WithStyles<"container">

const NarrowInfoContainer: React.SFC<ContainerProps> = (props) => {
    return <Paper className={props.classes.container}>
        <Grid container direction="column" alignItems="center" spacing={4}>
            {props.children}
        </Grid>
    </Paper>
}

export default withStyles(styles)(NarrowInfoContainer);


// WEBPACK FOOTER //
// ./src/components/NarrowInfoContainer.tsx